import { useCallback } from 'react';
import { notificationAPI } from '../../services/notificationService';
import { useToast } from '../../components/UI';

export const useNotificationActions = (refetch: () => Promise<void>) => {
  const { addToast } = useToast();

  const markAsRead = useCallback(
    async (id: string) => {
      try {
        await notificationAPI.markAsRead(id);
        await refetch();
      } catch {
        addToast({ type: 'error', title: 'Erro', message: 'Não foi possível marcar como lida.' });
      }
    },
    [refetch, addToast]
  );

  const markAllAsRead = useCallback(async () => {
    try {
      await notificationAPI.markAllAsRead();
      await refetch();
      addToast({
        type: 'success',
        title: 'Sucesso',
        message: 'Todas as notificações foram marcadas como lidas.',
      });
    } catch {
      addToast({
        type: 'error',
        title: 'Erro',
        message: 'Não foi possível marcar todas como lidas.',
      });
    }
  }, [refetch, addToast]);

  return { markAsRead, markAllAsRead };
};
